import { VFlow } from 'bold-ui'
import { RadioGroupField } from 'components/form'
import { CiapSelectField } from 'components/form/field/select/CiapSelectField/CiapSelectField'
import { CidSelectField } from 'components/form/field/select/CidSelectField/CidSelectField'
import { usePecField } from 'components/form/final-form/hooks/useField'
import { CiapCapituloEnum, SexoEnum } from 'graphql/types.generated'
import React from 'react'
import { MetaRoot } from 'util/metaPath'

import { MedicamentoFormModel, TipoMotivoPrescricaoEnum } from '../../model-prescricao'

export interface MotivoPrescricaoSectionProps {
  path: MetaRoot<MedicamentoFormModel>
  podeRegistrarCid: boolean
  sexoCidadao: SexoEnum | null
  idadeCidadaoEmAnos?: number
}

export const MotivoPrescricaoSection = React.memo((props: Readonly<MotivoPrescricaoSectionProps>) => {
  const { path, podeRegistrarCid, sexoCidadao, idadeCidadaoEmAnos } = props

  const { input: tipoMotivoInput } = usePecField({
    name: path.tipoMotivoPrescricao.absolutePath(),
    subscription: { value: true },
  })

  const tipoMotivoPrescricao = tipoMotivoInput.value as TipoMotivoPrescricaoEnum

  return (
    <VFlow vSpacing={0}>
      {podeRegistrarCid && (
        <RadioGroupField
          name={path.tipoMotivoPrescricao.alias}
          label='Motivo da prescrição'
          options={[
            { value: TipoMotivoPrescricaoEnum.CID10, label: 'CID10' },
            { value: TipoMotivoPrescricaoEnum.CIAP2, label: 'CIAP2' },
          ]}
        />
      )}

      {tipoMotivoPrescricao === TipoMotivoPrescricaoEnum.CID10 && podeRegistrarCid ? (
        <CidSelectField
          name={path.cidMotivoPrescricao.alias}
          label='CID10'
          renderGrupoCiapRelacionada={false}
          sexo={sexoCidadao}
          idadeCidadaoEmAnos={idadeCidadaoEmAnos}
          required
        />
      ) : (
        <CiapSelectField
          name={path.ciapMotivoPrescricao.alias}
          label='CIAP2'
          sexo={sexoCidadao}
          idadeCidadaoEmAnos={idadeCidadaoEmAnos}
          capitulosExcluidos={[CiapCapituloEnum.PROCEDIMENTOS]}
          excluirCIAPsDAB
          required
        />
      )}
    </VFlow>
  )
})
